import React from "react";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import CustomExpire from "../components/CustomExpire";
import addCliente from "../services/addCliente";
import getProdotti from "../services/getProdotti";
import CustomPrice from "../components/CustomPrice";
import checkToken from "../services/checkToken";
import LoadingButton from "@mui/lab/LoadingButton/LoadingButton";
import _default from "../themes/default";
import addReminder from "../services/addReminder";
import { Stack, TextField } from "@mui/material";
import Utils from '../utils/utils';

const cookies = new Cookies();

export default class AddCliente extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            clientePrivato: false,
            ragioneSociale: '',
            p_iva: '',
            email: '',
            fatturazione: [],
            prodotti: [],
            incasso: [],
            provvigioni: [],
            provvigioniSegnalatore: [],
            regione: '',
            regioni: Utils.regioni,
            provincia: '',
            province: []
        };
    }

    current = cookies.get('userType', { path: '/' });
    
    async componentDidMount() {
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        this.prodotti = await getProdotti(username, token);
    }

    calculatePercentages() {
        var fatPerc = 0.0
        var incPerc = 0.0

        this.state.fatturazione.forEach(f => {
            fatPerc += parseFloat(f.percentage);
        });
        this.state.incasso.forEach(f => {
            incPerc += parseFloat(f.percentage);
        });

        this.setState({ fatPerc, incPerc });
    }

    handleRegioneChange = (event) => {
        const selectedRegione = event.target.value;
        const province = Utils.province;
        
        const filteredProvince = province.filter((provincia) => {
          return provincia.regione === selectedRegione;
        });
    
        this.setState({
          regione: selectedRegione,
          province: filteredProvince,
          provincia: '',
        });
    };

    render() {
        return (
            <>

                <PageTitle title={'Nuovo cliente'} />

                <Stack direction={'column'} spacing={2} sx={{ flex: 1 }} >

                <div style={{ display: 'flex', width: 300, alignItems: 'center', justifyContent: 'center' }}>
                    <p style={{ ...selectionButton, backgroundColor: this.state.clientePrivato ? 'darkgrey' : 'white', color: this.state.clientePrivato ? 'black' : 'darkgrey' }} onClick={() => this.setState({ clientePrivato: true })}>Privato</p>
                    <p style={{ ...rightSelectionButton, backgroundColor: !this.state.clientePrivato ? 'darkgrey' : 'white', color: !this.state.clientePrivato ? 'black' : 'darkgrey' }} onClick={() => this.setState({ clientePrivato: false })}>Azienda</p>
                </div>

                <Stack direction={'row'} spacing={2} sx={{ flex: 1 }} >
                    <Stack direction={'column'} spacing={2} sx={{ flex: 1 }} >
                <TextField
                    label={this.state.clientePrivato ? 'Nome e cognome' : 'Ragione Sociale'}
                    value={this.state.ragioneSociale}
                    onChange={(event) => { this.setState({ ragioneSociale: event.target.value }) }}
                />
                </Stack>
                <Stack direction={'column'} spacing={2} sx={{ flex: 1 }} >
                <TextField
                    label={this.state.clientePrivato ? 'Codice fiscale' : 'Partita IVA'}
                    value={this.state.partitaIva}
                    onChange={(event) => { this.setState({ partitaIva: event.target.value }) }}
                />
                </Stack>
                <Stack direction={'column'} spacing={2} sx={{ flex: 1 }} >
                <TextField
                    label={'Email'}
                    value={this.state.email}
                    onChange={(event) => { this.setState({ email: event.target.value }) }}
                />
                </Stack>
                {
                    (this.current === '0' || this.current === '3') && <Stack direction={'column'} spacing={2} sx={{ flex: 1 }} >
                        <TextField
                            label={'Fido'}
                            value={this.state.fido}
                            type={'number'}
                            onChange={(event) => { this.setState({ fido: event.target.value }) }}
                        />
                    </Stack>
                }
                </Stack>

                <div style={{ height: 30 }}></div>
                <Stack direction={'row'} spacing={2} sx={{ flex: 1 }} >
                    <Stack direction={'column'} spacing={2} sx={{ flex: 1 }} >
                <TextField
                    select
                    label={'Regione'}
                    value={this.state.regione}
                    onChange={(event) => this.handleRegioneChange(event)}
                    SelectProps={{
                        native: true,
                    }}
                >
                    <option value={''}></option>
                    {this.state.regioni.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </TextField>
                </Stack>
                <Stack direction={'column'} spacing={2} sx={{ flex: 1 }} >
                <TextField
                    select
                    label={'Provincia'}
                    value={this.state.provincia}
                    onChange={(event) => { this.setState({ provincia: event.target.value }) }}
                    SelectProps={{
                        native: true,
                    }}
                >
                    <option value={''}></option>
                    {this.state.province.map((option) => {
                        return (
                            <option key={option.nome} value={option.nome}>
                                {option.nome}
                            </option>
                        )
                    })}
                </TextField>
                </Stack>
                <Stack direction={'column'} spacing={2} sx={{ flex: 1 }} >
                <TextField
                    label={'Città'}
                    value={this.state.citta}
                    onChange={(event) => { this.setState({ citta: event.target.value }) }}
                />
                </Stack>
                <Stack direction={'column'} spacing={2} sx={{ flex: 1 }} >
                <TextField
                    label={'Via, corso, piazza, ...'}
                    value={this.state.indirizzo}
                    onChange={(event) => { this.setState({ indirizzo: event.target.value }) }}
                />
                </Stack>
                </Stack>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 20 }}>
                    <h3 style={{ marginLeft: 5, marginTop: 15 }}>Regole di fatturazione</h3>
                    <img src={require('../images/add.png')} alt="" style={{ marginLeft: 10, cursor: 'pointer', width: 20, height: 20 }} onClick={() => this.addCampo('fatturazione')} />
                </div>
                <p style={{ color: this.state.fatPerc !== 100.0 ? 'red' : 'darkgrey', marginTop: -15, marginLeft: 5 }}>{isNaN(this.state.fatPerc) ? 0 : this.state.fatPerc} % coperto</p>

                {this.state.fatturazione.length > 0 && this.state.fatturazione.map((fat, i) =>
                    <CustomExpire key={i} value={fat}
                        onPercUpdate={(newPerc) => {
                            var fatturazione = this.state.fatturazione;
                            fatturazione[i].percentage = newPerc;
                            this.setState({ fatturazione });
                            this.calculatePercentages();
                        }}

                        onDaysUpdate={(newDays) => {
                            var fatturazione = this.state.fatturazione;
                            fatturazione[i].days = newDays;
                            this.setState({ fatturazione });
                        }}

                        onFromUpdate={(newFrom) => {
                            var fatturazione = this.state.fatturazione;
                            fatturazione[i].from = newFrom;
                            this.setState({ fatturazione });
                        }}

                        onDelete={() => {
                            this.deleteCampo('fatturazione', i);
                        }}
                    />
                )}

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 20 }}>
                    <h3 style={{ marginLeft: 5, marginTop: 15 }}>Regole di incasso</h3>
                    <img src={require('../images/add.png')} alt="" style={{ marginLeft: 10, cursor: 'pointer', width: 20, height: 20 }} onClick={() => this.addCampo('incasso')} />
                </div>
                <p style={{ color: this.state.incPerc !== 100.0 ? 'red' : 'darkgrey', marginTop: -15, marginLeft: 5 }}>{isNaN(this.state.incPerc) ? 0 : this.state.incPerc} % coperto</p>

                {this.state.incasso.length > 0 && this.state.incasso.map((fat, i) =>
                    <CustomExpire key={i} value={fat}
                        onPercUpdate={(newPerc) => {
                            var incasso = this.state.incasso;
                            incasso[i].percentage = newPerc;
                            this.setState({ incasso });
                            this.calculatePercentages();
                        }}

                        onDaysUpdate={(newDays) => {
                            var incasso = this.state.incasso;
                            incasso[i].days = newDays;
                            this.setState({ incasso });
                        }}

                        onFromUpdate={(newFrom) => {
                            var incasso = this.state.incasso;
                            incasso[i].from = newFrom;
                            this.setState({ incasso });
                        }}

                        onDelete={() => {
                            this.deleteCampo('incasso', i);
                        }}
                    />
                )}

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 20 }}>
                    <h3 style={{ marginLeft: 5, marginTop: 15 }}>Regole delle provvigioni</h3>
                    <img src={require('../images/add.png')} alt="" style={{ marginLeft: 10, cursor: 'pointer', width: 20, height: 20 }} onClick={() => this.addCampo('provvigione')} />
                </div>

                {this.state.provvigioni.length > 0 && this.state.provvigioni.map((fat, i) =>
                    <CustomExpire key={i} value={fat}
                        onPercUpdate={(newPerc) => {
                            var provvigioni = this.state.provvigioni;
                            provvigioni[i].percentage = newPerc;
                            this.setState({ provvigioni });
                            this.calculatePercentages();
                        }}

                        onDaysUpdate={(newDays) => {
                            var provvigioni = this.state.provvigioni;
                            provvigioni[i].days = newDays;
                            this.setState({ provvigioni });
                        }}

                        onFromUpdate={(newFrom) => {
                            var provvigioni = this.state.provvigioni;
                            provvigioni[i].from = newFrom;
                            this.setState({ provvigioni });
                        }}

                        onDelete={() => {
                            this.deleteCampo('provvigione', i);
                        }}
                    />
                )}

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 20 }}>
                    <h3 style={{ marginLeft: 5, marginTop: 15 }}>Regole delle provvigioni (segnalatore)</h3>
                    <img src={require('../images/add.png')} alt="" style={{ marginLeft: 10, cursor: 'pointer', width: 20, height: 20 }} onClick={() => this.addCampo('provvigioneSegnalatore')} />
                </div>

                {this.state.provvigioniSegnalatore.length > 0 && this.state.provvigioniSegnalatore.map((fat, i) =>
                    <CustomExpire key={i} value={fat}
                        onPercUpdate={(newPerc) => {
                            var provvigioniSegnalatore = this.state.provvigioniSegnalatore;
                            provvigioniSegnalatore[i].percentage = newPerc;
                            this.setState({ provvigioniSegnalatore });
                            this.calculatePercentages();
                        }}

                        onDaysUpdate={(newDays) => {
                            var provvigioniSegnalatore = this.state.provvigioniSegnalatore;
                            provvigioniSegnalatore[i].days = newDays;
                            this.setState({ provvigioniSegnalatore });
                        }}

                        onFromUpdate={(newFrom) => {
                            var provvigioniSegnalatore = this.state.provvigioniSegnalatore;
                            provvigioniSegnalatore[i].from = newFrom;
                            this.setState({ provvigioniSegnalatore });
                        }}

                        onDelete={() => {
                            this.deleteCampo('provvigioneSegnalatore', i);
                        }}
                    />
                )}

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 20 }}>
                    <h3 style={{ marginLeft: 5, marginTop: 15 }}>Prezzi Prodotti personalizzati</h3>
                    <img src={require('../images/add.png')} alt="" style={{ marginLeft: 10, cursor: 'pointer', width: 20, height: 20 }} onClick={() => this.addCampo('prodotto')} />
                </div>

                {this.state.prodotti.length > 0 && this.state.prodotti.map((prod, i) =>
                    <CustomPrice key={i} value={prod}
                        prodotti={this.prodotti}

                        onProdottoSelect={(prodottoId) => {
                            let prodotti = this.state.prodotti;
                            prodotti[i].prodottoId = prodottoId;
                            this.setState({ prodotti });
                        }}

                        onPriceUpdate={(newPrice) => {
                            var prodotti = this.state.prodotti;
                            prodotti[i].price = newPrice;
                            this.setState({ prodotti });
                        }}

                        onDelete={() => {
                            this.deleteCampo('prodotto', i);
                        }}
                    />
                )}

                <div style={{ height: 30 }}></div>
                <LoadingButton sx={{ flex: 1, minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => this.save()}>Salva</LoadingButton>

                </Stack>
            </>
        );
    }

    deleteCampo(str, ind) {
        switch (str) {
            case 'fatturazione':
                var fat = this.state.fatturazione.filter((f, index) => index !== ind);
                this.setState({ fatturazione: [] });
                setTimeout(() => {
                    this.setState({ fatturazione: fat });
                    this.calculatePercentages();
                }, 10);
                break;
            case 'incasso':
                var inc = this.state.incasso.filter((f, index) => index !== ind);
                this.setState({ incasso: [] });
                setTimeout(() => {
                    this.setState({ incasso: inc });
                    this.calculatePercentages();
                }, 10);
                break;
            case 'provvigione':
                var prov = this.state.provvigioni.filter((f, index) => index !== ind);
                this.setState({ provvigioni: [] });
                setTimeout(() => {
                    this.setState({ provvigioni: prov });
                    this.calculatePercentages();
                }, 10);
                break;
            case 'provvigioneSegnalatore':
                var prov = this.state.provvigioniSegnalatore.filter((f, index) => index !== ind);
                this.setState({ provvigioniSegnalatore: [] });
                setTimeout(() => {
                    this.setState({ provvigioniSegnalatore: prov });
                    this.calculatePercentages();
                }, 10);
                break;
            case 'prodotto':
                var prod = this.state.prodotti.filter((f, index) => index !== ind);
                this.setState({ prodotti: [] });
                setTimeout(() => {
                    this.setState({ prodotti: prod });
                }, 10);

                break;
            default:
                break;
        }
    }

    checkEmail() {
        if (/^[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(this.state.email)) {
            this.setState({ errorEmail: false });
            return true;
        }
        return false;
    }

    async save() {

        this.setState({ isLoading: true });
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const check = await checkToken(username, token, true);
        const userType = parseInt(check.utente.tipo);
        let clientiLink = '';

        switch (userType) {
            case 0:
                clientiLink = '#/app/clienti';
                break;
            case 3:
                clientiLink = '#/commerciale/clienti';
                break;
            default:
                break;
        }



        if (!this.state.ragioneSociale) {
            alert('Inserire ' + (this.state.clientePrivato ? 'un nome valido' : 'una ragione sociale valida'));
            this.setState({ isLoading: false });
            return;
        }
        if (!this.state.fido) {
            alert('Inserire fido valido');
            this.setState({ isLoading: false });
            return;
        }

        if (!this.checkEmail()) {
            alert('Inserire un email valida');
            this.setState({ isLoading: false });
            return;
        }

        if (!this.state.partitaIva || (this.state.clientePrivato && this.state.partitaIva.length !== 16) || (!this.state.clientePrivato && (this.state.partitaIva.length !== 11 && this.state.partitaIva.length !== 13))) {
            alert('Inserire ' + (this.state.clientePrivato ? 'un codice fiscale valido' : 'una partita iva valida'));
            this.setState({ isLoading: false });
            return;
        }

        if (this.state.fatPerc !== 100.0) {
            alert('Non è stata gestita la fatturazione del 100% dell\'importo');
            this.setState({ isLoading: false });
            return;
        }

        if (this.state.incPerc !== 100.0) {
            alert('Non è stato gestito l\'incasso del 100% dell\'importo');
            this.setState({ isLoading: false });
            return;
        }

        var provPerc = 0.0
        this.state.provvigioni.forEach(p => {
            provPerc += p.percentage;
        });
        if (provPerc > 100.0) {
            alert('È stata inserita una percentuale totale di provvigione maggiore del 100%. Verifica i dati e riprova.');
            this.setState({ isLoading: false });
            return;
        }

        let percs = this.state.fatturazione.filter(f => !f.percentage || !f.days || !f.from);
        if (percs.length > 0) {
            alert('Ci sono alcuni campi incompleti nelle regole di fatturazione.');
            this.setState({ isLoading: false });
            return;
        }

        let incs = this.state.incasso.filter(i => !i.percentage || !i.days || !i.from);
        if (incs.length > 0) {
            alert('Ci sono alcuni campi incompleti nelle regole di incasso.');
            this.setState({ isLoading: false });
            return;
        }

        let provv = this.state.provvigioni.filter(p => !p.percentage || !p.days || !p.from);
        if (provv.length > 0) {
            alert('Ci sono alcuni campi incompleti nelle regole delle provvigioni.');
            this.setState({ isLoading: false });
            return;
        }

        let provvv = this.state.provvigioniSegnalatore.filter(p => !p.percentage || !p.days || !p.from);
        if (provvv.length > 0) {
            alert('Ci sono alcuni campi incompleti nelle regole delle provvigioni per i segnalatori.');
            this.setState({ isLoading: false });
            return;
        }

        let product = this.state.prodotti.filter(p => !p.price || !p.prodottoId);
        if (product.length > 0) {
            alert('Ci sono alcuni campi incompleti nei prezzi dei prodotti personalizzati.');
            this.setState({ isLoading: false });
            return;
        }

        if(!this.state.regione) {
            alert('Inserire una regione valida');
            this.setState({ isLoading: false });
            return;
        }

        if(!this.state.provincia) {
            alert('Inserire una provincia valida');
            this.setState({ isLoading: false });
            return;
        }

        let cliente = {
            ragione_sociale: this.state.ragioneSociale,
            p_iva: this.state.partitaIva,
            email: this.state.email,
            is_privato: this.state.clientePrivato,
            indirizzo: this.state.indirizzo,
            citta: this.state.citta,
            fatturazione: this.state.fatturazione,
            incasso: this.state.incasso,
            provvigioni: this.state.provvigioni,
            fido: this.state.fido,
            provvigioniSegnalatore: this.state.provvigioniSegnalatore,
            prodotti: this.state.prodotti,
            regione: this.state.regione, 
            provincia: this.state.provincia
        };

        let res = await addCliente(username, token, cliente);
        if (res.result === 'ok') {
            console.log(res)
            addReminder(username, token, 'Aggiunto cliente ' + this.state.ragioneSociale, 'amministrazione', 'cliente', res.id_cliente);
            window.location.href = clientiLink;
            return;
        }

        this.setState({ isLoading: false });
        alert('Si è verificato un errore durante la creazione del cliente. Per favore, riprova.');
    }

    addCampo(str) {
        switch (str) {
            case 'fatturazione':
                var fat = this.state.fatturazione;
                fat.push({});
                this.setState({ fatturazione: fat });
                break;
            case 'incasso':
                var inc = this.state.incasso;
                inc.push({});
                this.setState({ incasso: inc });
                break;
            case 'provvigione':
                var prov = this.state.provvigioni;
                prov.push({});
                this.setState({ provvigioni: prov });
                break;
            case 'provvigioneSegnalatore':
                var prov = this.state.provvigioniSegnalatore;
                prov.push({});
                this.setState({ provvigioniSegnalatore: prov });
                break;
            case 'prodotto':
                var prod = this.state.prodotti;
                prod.push({});
                this.setState({ prodotti: prod });
                break;
            default:
                break;
        }
    }

}

const selectionButton = {
    height: 30,
    width: 140,
    marginLeft: 5,
    borderTopLeftRadius: 15,
    borderBottomLeftRadius: 15,
    textAlign: 'center',
    paddingTop: 4,
    cursor: 'pointer'
}

const rightSelectionButton = {
    height: 30,
    width: 140,
    marginLeft: 5,
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    textAlign: 'center',
    paddingTop: 4,
    cursor: 'pointer'
}

